type ResourceMetricChartSliceId = 'used' | 'remaining-connected' | 'discovered';

type ResourceMetricChartSlice = {
  fill: string;
  id: ResourceMetricChartSliceId;
  value: number;
};

type ResourceMetricChartColors = {
  discovered: string;
  remainingConnected: string;
  used: string;
};

type GetResourceMetricChartDataArgs = {
  colors: ResourceMetricChartColors;
  connected: number;
  discovered: number;
  used: number;
};

export const getResourceMetricChartData = ({
  colors,
  connected,
  discovered,
  used,
}: GetResourceMetricChartDataArgs): ResourceMetricChartSlice[] =>
  [
    { id: 'used' as const, value: used, fill: colors.used },
    {
      id: 'remaining-connected' as const,
      value: Math.max(connected - used, 0),
      fill: colors.remainingConnected,
    },
    {
      id: 'discovered' as const,
      value: discovered,
      fill: colors.discovered,
    },
  ].filter((slice) => slice.value > 0);
